import { render, staticRenderFns } from "./Districomgaz.vue?vue&type=template&id=ee04729a&"
import script from "./Districomgaz.vue?vue&type=script&lang=js&"
export * from "./Districomgaz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports